(() => {
  let enabled = false, message = '', revision = 0, saved = 0, running, timer, replay = false;
  const blocks = () => [...document.querySelectorAll('[data-gift-card]')];
  const initial = blocks()[0];
  if (!initial) return;
  enabled = initial.dataset.enabled === 'Sí';
  message = initial.dataset.message || '';
  function paint(status = '') {
    blocks().forEach(block => {
      block.querySelector('[data-gift-toggle]').checked = enabled;
      block.querySelector('[data-gift-value]').value = enabled ? 'Sí' : '';
      block.querySelector('[data-gift-fields]').hidden = !enabled;
      const field = block.querySelector('[data-gift-message]');
      if (field.value !== message) field.value = message;
      block.querySelector('[data-gift-count]').textContent = message.length + ' / 250';
      block.querySelector('[data-gift-status]').textContent = status ? block.dataset[status] : '';
    });
    document.querySelectorAll('.cart-page__accelerated').forEach(el => {
      el.inert = saved !== revision;
      el.setAttribute('aria-busy', String(saved !== revision));
    });
  }
  async function flush() {
    clearTimeout(timer);
    if (running) await running;
    if (saved === revision) return;
    const target = revision;
    paint('saving');
    running = (async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Tarjeta de regalo': enabled ? 'Sí' : '', 'Mensaje para tarjeta de regalo': enabled ? message : '' } })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      const attrs = cart.attributes || {};
      if (target === revision && ((attrs['Tarjeta de regalo'] || '') !== (enabled ? 'Sí' : '') || (attrs['Mensaje para tarjeta de regalo'] || '') !== (enabled ? message : ''))) throw new Error('Cart attribute mismatch');
      saved = target;
    })();
    try { await running; } catch (error) { paint('error'); throw error; } finally { running = null; }
    if (saved !== revision) return flush();
    paint();
  }
  function changed() {
    revision++;
    paint('saving');
    clearTimeout(timer);
    timer = setTimeout(() => flush().catch(() => {}), 250);
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-gift-message]')) return;
    message = event.target.value.slice(0, 250);
    changed();
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-gift-toggle]')) return;
    enabled = event.target.checked;
    if (!enabled) message = '';
    changed();
    blocks().forEach(block => block.querySelector('[data-gift-fields]').open = enabled);
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a');
    if (!link || !link.closest('#cartDrawer, [data-cart-page]') || saved === revision) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try { await flush(); window.location.assign(link.href); } catch (_) {}
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (replay || !form.matches('.cart-page__form') || saved === revision) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter;
    try {
      await flush();
      replay = true;
      form.requestSubmit(submitter || undefined);
      replay = false;
    } catch (_) { replay = false; }
  }, true);
  window.CartujaGiftCard = { flush, sync(cart) {
    if (saved !== revision) return;
    enabled = cart.attributes?.['Tarjeta de regalo'] === 'Sí';
    message = enabled ? (cart.attributes?.['Mensaje para tarjeta de regalo'] || '') : '';
    paint();
  } };
  document.addEventListener('shopify:section:load', () => paint());
  paint();
})();

